<template>
  <div>
    <div class="help-image">
      <img src="@/assets/btn_help.png" alt="helpImage" @click="openhelp" />
    </div>
    <div v-if="showhelp" class="modal-overlay" @click="closehelp">
      <div class="modal-content" @click.stop>
        <!-- <button class="modal-close-button" @click="closeModal">✖</button> -->
        <img
          src="@/assets/modal-close.png"
          alt="閉じる"
          class="close-button"
          @click="closehelp"
        />
        <img
          src="@/assets/help_share.png"
          class="help-share-button"
        />
        <!-- <img
          src="@/assets/help_position.png"
          class="help-position-button"
        /> -->
        <img
          src="@/assets/help_save.png"
          class="help-save-button"
        />
        <img
          src="@/assets/help_submit.png"
          class="help-submit-button"
        />
        <img
          src="@/assets/help_ai.png"
          class="help-ai-button"
        />
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Help',
  data () {
    return {
      showhelp: false
    }
  },
  methods: {
    closehelp () {
      this.showhelp = false // モーダルを閉じる
    },
    openhelp () {
      this.showhelp = true
    }
  }
}

</script>

<style scoped>

.help-image {
  /* height: 150px; 画像の高さ */
  /* background-color: #f5f5f5;
  display: flex;
  justify-content: center;
  align-items: center; */
  position: absolute;
  right: 10px;
  z-index: 100;
  top: 10px;
  cursor: pointer;
}

/* モーダルオーバーレイ */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 16777272;
}

/* モーダルコンテンツ */
.modal-content {
  /* background: #FFFBF7;
  padding: 20px;
  text-align: center;
  position: relative;
  max-width: 500px;
  width: 90%;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  animation: fadeIn 0.3s ease; */
}

.modal-close-button {
  position: absolute;
  top: 20px;
  right: 20px;
  border: none;
  background: none;
  font-size: 18px;
  cursor: pointer;
  color: #ff5b5b;
}

.modal-close-button:hover {
  color: #ff0000;
}

.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 24px;
  height: 24px;
  cursor: pointer;
}

.help-share-button {
  position: absolute;
  bottom: 130px;
  left: 10px;
}

.help-position-button {
  position: absolute;
  bottom: 195px;
  right: 10px;
}

.help-save-button {
  position: absolute;
  bottom: 50px;
  left: 40px;
}

.help-submit-button {
  position: absolute;
  bottom: 50px;
  left: 460px;
}

.help-ai-button {
  position: absolute;
  bottom: 130px;
  left: 325px;
}

</style>
